/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { FieldHint, FieldLabel, InputField, TextInputProps } from '@flodesk/grain';
import { forwardRef } from 'react';

type TextInputWithSuffixProps = TextInputProps & {
  suffix?: string;
};

const TextInputWithSuffix = forwardRef<HTMLInputElement, TextInputWithSuffixProps>(
  ({ label, hint, suffix, id, size: _size, ...inputProps }, ref) => {
    const fieldMarginTop = label || hint ? 'var(--grn-form-control-label-gap)' : undefined;
    const paddingRight = suffix ? `calc(var(--grn-field-paddingX) * 2 + 2ch)` : undefined;

    return (
      <div>
        {label && <FieldLabel htmlFor={id}>{label}</FieldLabel>}
        {hint && <FieldHint>{hint}</FieldHint>}
        <div
          css={css`
            position: relative;
            ${fieldMarginTop ? `margin-top: ${fieldMarginTop};` : ''}
          `}
        >
          <InputField ref={ref} id={id} paddingRight={paddingRight} {...inputProps} />
          {suffix && (
            <span
              css={css`
                position: absolute;
                right: var(--grn-field-paddingX);
                top: 0;
                bottom: 0;
                margin: auto;
                height: fit-content;
                font-size: 14px;
                color: var(--grn-color-content2);
                pointer-events: none;
              `}
            >
              {suffix}
            </span>
          )}
        </div>
      </div>
    );
  },
);

export default TextInputWithSuffix;
